"use client";

import { useEffect } from "react";

/**
 * Ensures _fbc cookie exists when landing with fbclid on the URL.
 * This complements the middleware (which may be bypassed by some client-side
 * navigations) to improve fbc coverage across subsequent events.
 */
export default function FbcBootstrap() {
  useEffect(() => {
    try {
      const url = new URL(window.location.href);
      const fbclid = url.searchParams.get("fbclid");
      if (!fbclid) return;
      // Only set if missing
      const hasFbc = document.cookie.includes("_fbc=");
      if (hasFbc) return;
      // IMPORTANT: use milliseconds for creation_time in _fbc per Meta spec
      const nowMs = Date.now();
      const fbc = `fb.1.${nowMs}.${fbclid}`;
      // Best-effort cookie; domain/samesite handled by browser defaults here
      document.cookie = `_fbc=${encodeURIComponent(fbc)}; path=/; max-age=${
        90 * 24 * 60 * 60
      }`;
    } catch {}
  }, []);
  return null;
}
